import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TriggerStylesService {

  constructor() {
  }

  getTriggerConfigurationStatusClass(isActive: boolean | null): string {
    if (!isActive) {
      return 'status-danger';
    }
    return 'status-success';
  }

  getTriggerConfigurationVisibilityClass(isVisible: boolean | null): string {
    if (isVisible) {
      return 'visible';
    }
    return 'hidden';
  }

  getTriggerConfigurationBadgeClass(isActive: boolean): string {
    if (!isActive) {
      return 'badge-danger';
    }
    return 'badge-success';
  }

  getTriggerConfigurationCircleClass(isActive: boolean): string {
    if (!isActive) {
      return 'fa-pause-circle';
    }
    return 'fa-play-circle';
  }

  getTriggerConfigurationActiveWord(isActive: boolean): string {
    if (!isActive) {
      return 'Inactive';
    }
    return 'Active';
  }
}
